export default class Conta {
    constructor(admin, conta, email, gravatarProfile, id_usuario, nome, colaborador, favEmails, notificacoes,primAcesso,imagem) {
        this.admin = admin;
        this.conta = conta;
        this.email = email;
        this.gravatarProfile = gravatarProfile;
        this.id_usuario = id_usuario;
        this.nome = nome;
        this.colaborador = colaborador;
        this.favEmails = favEmails;
        this.notificacoes = notificacoes;
        this.primAcesso = primAcesso;
        this.imagem = imagem;
        this.getEmpresas = false;
        this.getLog = false;
        this.getNotificacoes = false;
        this.getNewImage = false;
    }
}


// WEBPACK FOOTER //
// ./src/domain/conta/Conta.js